import { createBrowserHistory } from 'history';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;

/**
 * Export a usable browser history for navigation.
 * Configuration object can be passed here if needed.
 */
export default createBrowserHistory({ basename: baseUrl });
